export const SHOW_INGOMBRANTI_MODAL = "showDispositivoModal"
export const HIDE_INGOMBRANTI_MODAL = "hide_Dispositivo_modal"

export function showIngombrantiModal(type, header, f, obj){
  return {
      type: SHOW_INGOMBRANTI_MODAL,
      payload:{
        type: type,
        header: header,
        function: f,
        obj: obj
    }
  }
}

export function hideIngombrantiModal(){
  return {
      type: HIDE_INGOMBRANTI_MODAL
  }
}